var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component"},'component',[_vm.isRouterLink ? { to: _vm.href } : { href: _vm.href }],false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }